import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
import { Message } from "element-ui";

const notification = {
  state: () => ({
    items: {
        pending : [],
        coming: [],
        past: [],
    },
    
  }),
  actions: {
    async approveAppointment(store,payload){
      var res = await axios.post('notification/approveappointment', {id : payload});
      if(res.data.hasError){
        Message.error(res.data.message);
      }else {
        Message.success(res.data.message);
        await store.dispatch('getAppointmentList');
      }
      return res;
    },
    async rejectAppointment(store,payload){
      var res = await axios.post('notification/rejectappointment', {id : payload});
      if(res.data.hasError){
        Message.error(res.data.message);
      }else {
        Message.success(res.data.message);
        await store.dispatch('getAppointmentList');
      }
      return res;
    },
    async removeeAppointment(store,payload){
      var res = await axios.post('notification/removeappointment', {id : payload});
      if(res.data.hasError){
        Message.error(res.data.message);
      }else {
        Message.success(res.data.message);
        await store.dispatch('getAppointmentList');
      }
      return res;
    },
    async getAvailableTimes(store,payload){
      var res = await axios.post('notification/getavailabletimes', payload);
      return res;
    },
    async createAppointment(store,payload){
      var res = await axios.post('notification/createappointment', payload);
      if(res.data.hasError){
        Message.error(res.data.message);
      }else {
        Message.success(res.data.message);
        await store.dispatch('getAppointmentList');
      }
      return res;
    },
    async getAppointmentList(store) {
        var res = await axios.post('Notification/ListAppointments');
        if(!res.data.hasError){
            store.commit('setAppointmentList',res.data.data);
        }
    }
  },
  mutations: {
    setAppointmentList(state,payload){
        state.items.pending = payload.pending.map(x => {return {...x,isCollapse:false}});
        state.items.past = payload.past.map(x => {return {...x,isCollapse:false}});
        state.items.coming = payload.coming.map(x => {return {...x,isCollapse:false}});
    }
  },
  getters: {
    getAppointmentList: state => state.items
  }
};

export default notification;



// WEBPACK FOOTER //
// ./src/store/notification.js